import { render, staticRenderFns } from "./ProceduresComingSoonPage.vue?vue&type=template&id=01afc549&scoped=true"
import script from "./ProceduresComingSoonPage.vue?vue&type=script&lang=js"
export * from "./ProceduresComingSoonPage.vue?vue&type=script&lang=js"
import style0 from "./ProceduresComingSoonPage.vue?vue&type=style&index=0&id=01afc549&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01afc549",
  null
  
)

export default component.exports